// Message contract shared with the host-page loader (public/sure-chat.js).
// Keep both sides in sync when adding a message type.

export const PROTOCOL_VERSION = 1;

export const MSG = {
  PARENT_READY: 'sure_parent_ready',
  CMD: 'sure_cmd',
  STATE: 'sure_state',
  STATE_REQUEST: 'sure_state_request',
  RESIZE: 'resizeChatIframe',
  MESSAGE_POSTED: 'sure_message_posted',
};

export const HOST_ACTIONS = new Set(['open', 'close', 'toggle', 'sync']);

// The loader appends ?launcher=external when the host page renders its own chat
// button. In that mode the host owns open/close and the built-in launcher bubble
// is never rendered, so channelSettings.isFolded no longer drives visibility.
export const IS_EXTERNAL_LAUNCHER = (() => {
  try {
    return new URLSearchParams(window.location.search).get('launcher') === 'external';
  } catch {
    return false;
  }
})();

// Serializes to a bare origin (scheme://host[:port]); null for anything unusable,
// including the opaque "null" that a masked ancestor or sandboxed parent reports.
const toOrigin = (value) => {
  if (typeof value !== 'string' || !value) return null;
  try {
    const { origin } = new URL(value);
    return origin && origin !== 'null' ? origin : null;
  } catch {
    return null;
  }
};

// Origin of the page that embeds the chat, for the socket handshake. `win` is a
// window-like object; `handshakeOrigin` is the browser-verified origin of the
// loader's sure_parent_ready message, if it has arrived.
export function getEmbeddingSiteOrigin(win, handshakeOrigin) {
  try {
    if (win.parent === win) return toOrigin(win.location?.origin);

    // Index 0 is the immediate parent (the page running the loader); the last
    // entry is the top-level page.
    const ancestors = win.location?.ancestorOrigins;
    if (ancestors && ancestors.length > 0) {
      const parent = toOrigin(ancestors[0]);
      if (parent) return parent;
    }

    return toOrigin(handshakeOrigin) || toOrigin(win.document?.referrer);
  } catch {
    return null;
  }
}
